import {StyleParamType, createStylesParams, getSettingsValues} from '@wix/tpa-settings'

import {Alignment, FormLayout} from '../../../../../types/createStylesParams'

import {layoutSettingsParams} from './settingsParams'

export type LayoutStylesParams = {
  breadcrumbsAlignment: StyleParamType.Number
  spaceBetweenTitleAndDescription: StyleParamType.Number
  spaceBetweenTextAndForm: StyleParamType.Number
  spaceBetweenFormAndTimeSlots: StyleParamType.Number
  spaceBetweenFormAndAreas: StyleParamType.Number
  spaceBetweenAreasAndTimeSlots: StyleParamType.Number
  sidePadding: StyleParamType.Number
  topBottomPadding: StyleParamType.Number
  buttonPadding: StyleParamType.Number
}

export const layoutStylesParams = createStylesParams<LayoutStylesParams>({
  breadcrumbsAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
  },
  spaceBetweenTitleAndDescription: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: () => 20,
  },
  spaceBetweenTextAndForm: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: (params) => (params.isMobile ? 40 : 80),
  },
  spaceBetweenFormAndTimeSlots: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: (params) => {
      const layoutSettings = getSettingsValues({}, layoutSettingsParams)
      const isFormStripLayout = layoutSettings.formLayout === FormLayout.Strip
      const value = isFormStripLayout ? 80 : 120
      return params.isMobile ? 40 : value
    },
  },
  spaceBetweenFormAndAreas: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: () => 120,
  },
  spaceBetweenAreasAndTimeSlots: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: () => 40,
  },
  sidePadding: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: (params) => (params.isMobile ? 0 : 40),
  },
  topBottomPadding: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: (params) => (params.isMobile ? 20 : 40),
  },
  buttonPadding: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: () => 20,
  },
})

export type AreasLayoutStylesParams = {
  spaceBetweenAreaCards: StyleParamType.Number
  areasTopBottomPadding: StyleParamType.Number
  areasSidePadding: StyleParamType.Number
}

export const areasLayoutStylesParams = createStylesParams<AreasLayoutStylesParams>({
  spaceBetweenAreaCards: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: () => 20,
  },
  areasTopBottomPadding: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: () => 16,
  },
  areasSidePadding: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: () => 16,
  },
})
